<template lang="pug">
  .map-conaier(:class="{ show: showMap }")
    MglMap(
      ref="mapbox"
      :accessToken="mapboxKey"
      :mapStyle="style"
      :center="calculatedCenter"
      :zoom="calculatedZoom"
      :max-zoom="18"
      :min-zoom="2.5"
      :interactive="false"
      @load="loaded"
    )
      MglMarker(
        v-if="marker"
        :coordinates="marker"
        :color="color"
      )
        // i.fa-map-marker-alt.fas(slot="marker" :style="{ color }")
        template(v-slot:marker)
          .map-marker-alt
            svg(
              :style="{ color }"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              :fill="color"
            )
              path(
                fill-rule="evenodd"
                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                clip-rule="evenodd"
              )
      MglMarker(
        v-else-if="notFoundMarker"
        :coordinates="notFoundMarker"
        :color="color"
      )
        // i.fa-map-marker-alt.fas(slot="marker" :style="{ color }")
        template(v-slot:marker)
          .map-marker-alt
            svg(
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            )
              path(
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                clip-rule="evenodd"
              )
</template>

<script>
import { mapGetters } from 'vuex';

import MultiTouch from 'mapbox-gl-multitouch';
import { MglMap, MglMarker } from 'vue-mapbox';

export default {
    name: 'MapBox',
    data() {
        return {
            style: 'mapbox://styles/vanameland/ckclxo9az13jn1io5gnwr9tjr',
            color: '#be1521',
            germany: [10.4515, 51.1657],
            center: [10.4515, 51.1657],
            zoom: 2.5,
            showMap: false
        };
    },
    props: {
        address: {
            type: [Object, Boolean],
            required: false
        },
        padding: {
            type: Object,
            required: false
        }
    },
    components: {
        MglMap,
        MglMarker
    },
    watch: {
        address() {
            this.$nextTick(() => {
                this.$refs.mapbox.map.resize();
            });
        },
        padding(padding) {
            if (this.$refs.mapbox.map) {
                this.$refs.mapbox.map.easeTo({
                    padding,
                    duration: 1000
                });
            }
        }
    },
    computed: {
        marker() {
            let marker;
            if (this.address && this.address.data) marker = this.address.data.center;
            else if (this.address && this.address.latitude && this.address.longitude) {
                marker = [this.address.latitude, this.address.longitude];
            }
            return marker;
        },
        notFoundMarker() {
            let marker;
            if (this.address === false || !(this.address && this.address.latitude && this.address.longitude)) {
                marker = this.center;
            }
            return marker;
        },
        calculatedCenter: {
            get() {
                let center = this.center;
                if (this.marker) center = this.marker;
                return center;
            },
            set(value) {
                this.center = value;
            }
        },
        calculatedZoom: {
            get() {
                let zoom = this.zoom;
                if (this.marker) zoom = 14;
                return zoom;
            },
            set(value) {
                this.zoom = value;
            }
        },
        ...mapGetters({
            mapboxKey: 'mapboxKey'
        })
    },
    methods: {
        async loaded(event) {
            // const language = 'de'

            let map = event.map;
            // map.setLayoutProperty('country-label', 'text-field', [ 'get', 'name_' + language ]);

            setTimeout(() => (this.showMap = true), 50);
            if (this.padding) {
                map.setPadding(this.padding);
            }

            map.addControl(new MultiTouch());
        }
    }
};
</script>

<style lang="sass" scoped>
.map-conaier
  @apply bg-gray-100 flex
  min-height: 160px
  @screen md
    min-height: 320px
  .mgl-map-wrapper
    opacity: 0
    transition: opacity .3s ease
    height: auto
  &.show .mgl-map-wrapper
    opacity: 1

  .mapboxgl-marker
    font-size: 2rem
    line-height: 2rem
    height: 1.8rem
    width: 2rem
    &:after
      content: ''
      position: absolute
      width: 10px
      height: 0px
      bottom: -2px
      left: calc(50% - 5px)
      box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.8)
</style>
